/**
 * responsible for loading micro application resource files
 */
const resourceLoader = (() => {
  /**
   * creates an element and attach to DOM
   * @param {String} tag - HTML Element Name ['script', 'link']
   * @param {String} url - url to be attached to an element
   * @param {String} rel - 'rel' attritube to be attached if tag='link'
   * @param {String} rscType - 'as' attritube to be attached if tag='link'
   * @returns {Promise}
   */
  const load = (tag) => (url, rel, rscType) => new Promise(((resolve, reject) => {
    const element = document.createElement(tag);
    let parent = 'body';
    element.onload = () => {
      resolve(url);
    };
    element.onerror = () => {
      reject(new Error(`unable to load ${url}`));
    };
    switch (tag) {
      case 'script':
        element.async = true;
        element.src = url;
        element.setAttribute('crossorigin', 'anonymous');
        break;
      case 'link':
        element.rel = rel || 'stylesheet';
        if (rscType) element.as = rscType;
        else element.type = 'text/css';
        element.href = url;
        parent = 'head';
        break;
      default: break;
    }

    document[parent].appendChild(element);
  }));

  /**
   * returns file type based on file extension
   * @param {String} fileName
   * @returns {String} fileType
   */
  const getFileType = (fileName) => {
    const extTypeMapping = {
      js: 'script',
      css: 'link',
    };

    return extTypeMapping[fileName.split('.').pop()];
  };

  /**
   * calls load function to attach a 'link' HTMLElement to dom to prefetch a file
   * @param {String} baseUrl - domain url
   * @param {String} fileName - file to prefetch
   * @returns {Promise}
   */
  const preFetch = (baseUrl, fileName) => {
    const rel = 'prefetch'; // indication to browser to prefetch the resource
    let rscType = getFileType(fileName);
    if (rscType === 'link') rscType = 'stylesheet';
    return load('link')(`${baseUrl}/${fileName}`, rel, rscType);
  };

  return {
    fetch: (baseUrl, fileName) => load(getFileType(fileName))(`${baseUrl}/${fileName}`),
    load,
    preFetch,
  };
})();

export default resourceLoader;
